"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.previewDoctorSubstituteContractsResponseSchema = void 0;
const zod_1 = require("zod");
exports.previewDoctorSubstituteContractsResponseSchema = zod_1.z.object({
    data: zod_1.z.array(zod_1.z.object({
        retrocessionRate: zod_1.z.number(),
        slotsCount: zod_1.z.number(),
        contractExists: zod_1.z.boolean(),
    })),
});
